import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { MultiSelect } from "../../../_models";
import { FormGroup, NgForm } from "@angular/forms";

import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "multiselect",
  templateUrl: "multi-select.component.html",
  styleUrls: ["./multi-select.component.scss"],
})
export class MultiSelectComponent extends BaseComponent {
  @Input() public multiSelectData: MultiSelect;
  @Input() public form: NgForm;
  @Input("customMultiSelect") public customMultiSelect:
    | "legacy"
    | "users"
    | "discountScreen"
    | "nests" = "legacy";
  @ViewChild("dropdown") public dropdown: ElementRef;
  @ViewChild("dropdownButton") public dropdownButton: ElementRef;
  @ViewChild("eventTemplate") public eventTemplate: Component;
  @ViewChild("multiselectInput") public multiselectInput: ElementRef;

  public dropdownIsOpen = false;
  public selectedData = [];
  public data = [];
  public formGroupObj: FormGroup;
  public searching: boolean;
  public postData = [];

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    private renderer: Renderer2,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);

    // close dropdown on click outside
    this.renderer.listen("window", "click", (e: Event) => {
      if (
        this.dropdownButton &&
        !this.dropdownButton.nativeElement.contains(event.target) &&
        this.dropdown &&
        !this.dropdown.nativeElement.contains(e.target)
      ) {
        this.dropdownIsOpen = false;
      }
    });
  }

  public run() {
    this.getDataWithTerm("");

    if (this.multiSelectData.initData) {
      this.multiSelectData.initData.forEach((item) => {
        const indexInselectedData = this.selectedData.indexOf(item);
        if (indexInselectedData !== -1) {
          this.selectedData.splice(indexInselectedData, 1);
        } else {
          this.selectedData.push(item);
        }
      });
    }
  }

  public getDataWithTerm(term: string) {
    if (this.multiSelectData.url) {
      this.searching = true;
      const postEntity = {
        text: term,
        CurrentYearSelected: this.multiSelectData["currentYearSelected"],
      };
      this.dataService
        .postEntityMultiSelect(
          this.multiSelectData.url,
          postEntity,
          this.multiSelectData.dataName
        )
        .subscribe((postData) => {
          this.postData = postData;
          if (this.multiSelectData.type === "events") {
            const currentYearCollectionName = `דמי חבר לשנת ${this.multiSelectData.currentYearName}`;
            if ((currentYearCollectionName + "אוסף").includes(term)) {
              postData.unshift({
                eventType: 501,
                name: currentYearCollectionName,
              });
            }
          }

          this.searching = false;
          this.updateDropdownListData();
        });
    } else {
      if (this.multiSelectData.data) {
        this.postData = this.multiSelectData.data.filter(
          (item) => item.name.toUpperCase().indexOf(term.toUpperCase()) > -1
        );
        const maximumDataLength = 30;
        if (this.postData.length > maximumDataLength) {
          this.postData.splice(
            maximumDataLength,
            this.postData.length - maximumDataLength
          );
        }
        this.updateDropdownListData();
      }
    }
  }

  updateDropdownListData() {
    if (this.multiSelectData.type && this.multiSelectData.type == "nests") {
      // hide nests/ counties that their containing county/ circle has been selected

      // selected data
      let selectedCircles = this.selectedData.filter(
        (item) => item.type === "circle"
      );
      let selectedCounties = this.selectedData.filter(
        (item) => item.type === "county"
      );
      let selectedNests = this.selectedData.filter(
        (item) => item.type === "nest"
      );
      selectedCounties = selectedCounties.filter(
        (county) =>
          selectedCircles.find((circle) => circle.id == county.parentCircle) ==
          undefined
      );
      selectedNests = selectedNests.filter(
        (nest) =>
          selectedCircles.find((circle) => circle.id == nest.parentCircle) ==
          undefined
      );
      selectedNests = selectedNests.filter(
        (nest) =>
          selectedCounties.find((county) => county.id == nest.parentCounty) ==
          undefined
      );
      this.selectedData = selectedCircles.concat(
        selectedCounties.concat(selectedNests)
      );

      // post data
      const circles = this.postData.filter((item) => item.type == "circle");
      let counties = this.postData.filter((item) => item.type == "county");
      let nests = this.postData.filter((item) => item.type == "nest");
      counties = counties.filter(
        (county) =>
          selectedCircles.find((circle) => circle.id == county.parentCircle) ==
          undefined
      );
      nests = nests.filter(
        (nest) =>
          selectedCircles.find((circle) => circle.id == nest.parentCircle) ==
          undefined
      );
      nests = nests.filter(
        (nest) =>
          selectedCounties.find((county) => county.id == nest.parentCounty) ==
          undefined
      );

      let filteredPostData = circles.concat(counties.concat(nests));

      this.data = this.mergeWithoutDuplicates(
        this.selectedData,
        filteredPostData
      );
    } else {
      this.data = this.mergeWithoutDuplicates(this.selectedData, this.postData);
    }
  }

  mergeWithoutDuplicates(array1: any, array2: any) {
    let returnedArray = array1 ? array1.slice() : [];
    if (array2) {
      for (let i = 0; i < array2.length; i++) {
        if (array1.indexOf(array2[i]) == -1) {
          returnedArray.push(array2[i]);
        }
      }
    }

    return returnedArray;
  }

  public onItemClick(clickedItem: any) {
    let indexInselectedData = this.selectedData.indexOf(clickedItem);
    if (indexInselectedData !== -1) {
      this.selectedData.splice(indexInselectedData, 1);
    } else {
      this.selectedData.push(clickedItem);
    }
    this.updateDropdownListData();
  }

  public isSelected(selectedItem: any) {
    let indexInselectedData = this.selectedData.indexOf(selectedItem);
    if (indexInselectedData == -1) {
      return false;
    }
    return true;
  }

  public getSelectedDataString() {
    return this.selectedData.map((s) => s.name).join(", ");
  }

  public multiselectBtnClick(ev) {
    const path = ev.path || ev.composedPath();
    if (path.includes(this.multiselectInput.nativeElement)) {
      this.dropdownIsOpen = true;
    } else if (!this.dropdownIsOpen) {
      this.multiselectInput.nativeElement.focus();
      this.dropdownIsOpen = true;
    } else {
      this.multiselectInput.nativeElement.blur();
      this.dropdownIsOpen = false;
      this.multiselectInput.nativeElement.value = "";
    }
  }

  public submit() {
    let r = {};
    r[this.multiSelectData.formControlName] = [];
    this.selectedData.forEach((item) => {
      let term: any;
      if (this.multiSelectData.type && this.multiSelectData.type === "nests") {
        term = { id: item.id, type: item.type };
      } else if (
        this.multiSelectData.type &&
        this.multiSelectData.type === "events"
      ) {
        term = { id: item.id, eventType: item.eventType };
      } else {
        term = item.id ? item.id : item.key ? item.key : item;
      }
      +r[this.multiSelectData.formControlName].push(term);
    });
    return r;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/multi-select/multi-select.component.ts